import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { APP_ENVIRONMENT } from '@core/config/app-environment';

/** Paths served with the public custom token instead of the picker session. */
export function isPublicTokenPath(path: string): boolean {
  return path.startsWith('/withdraws') || path.startsWith('/queue-manager') || path.startsWith('/auth');
}

/**
 * Cookie-based auth (no Authorization header). Port of legacy authInterceptor: only requests
 * to `BASE_API` get `withCredentials` and `x-requested-by: rt-web`; on public pages
 * (`/withdraws`, `/queue-manager`, `/auth`) the request carries `tipo-auth: CustomToken` instead.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const env = inject(APP_ENVIRONMENT);
  const shouldSendCookies = req.url.startsWith(env.BASE_API);

  if (!shouldSendCookies) {
    return next(req);
  }

  let authReq = req.clone({
    withCredentials: true,
    setHeaders: { 'x-requested-by': 'rt-web' },
  });

  if (isPublicTokenPath(window.location.pathname)) {
    authReq = req.clone({
      withCredentials: true,
      setHeaders: { 'tipo-auth': 'CustomToken' },
    });
  }

  return next(authReq);
};
